import { BttvEmote, SeventvEmote, TwitchEmote } from '../../types/emote.js';

const SeventvEmotes = [
  {
    id: '01FCY771D800007PQ2DF3GDTN6',
    name: 'RainTime',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01FCY771D800007PQ2DF3GDTN6/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01FCY771D800007PQ2DF3GDTN6/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01FCY771D800007PQ2DF3GDTN6/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01FCY771D800007PQ2DF3GDTN6/4x.webp',
    },
  },
  {
    id: '01FE3XY508000AA32JP519W2EW',
    name: 'PETPET',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01FE3XY508000AA32JP519W2EW/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01FE3XY508000AA32JP519W2EW/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01FE3XY508000AA32JP519W2EW/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01FE3XY508000AA32JP519W2EW/4x.webp',
    },
  },
  {
    id: '01GGD5PJA8000FH13S498E9D8X',
    name: 'ppL',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GGD5PJA8000FH13S498E9D8X/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GGD5PJA8000FH13S498E9D8X/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GGD5PJA8000FH13S498E9D8X/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GGD5PJA8000FH13S498E9D8X/4x.webp',
    },
  },
  {
    id: '01GB2TN09G000AZXHZ8HNEZX6G',
    name: 'Clap2',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB2TN09G000AZXHZ8HNEZX6G/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB2TN09G000AZXHZ8HNEZX6G/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB2TN09G000AZXHZ8HNEZX6G/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB2TN09G000AZXHZ8HNEZX6G/4x.webp',
    },
  },
  {
    id: '01GAM8EFQ00004MXFXAJYKA859',
    name: 'Clap',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GAM8EFQ00004MXFXAJYKA859/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GAM8EFQ00004MXFXAJYKA859/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GAM8EFQ00004MXFXAJYKA859/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GAM8EFQ00004MXFXAJYKA859/4x.webp',
    },
  },
  {
    id: '01GAFTZ9K80003DHH026MC7JW0',
    name: 'PepePls',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GAFTZ9K80003DHH026MC7JW0/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GAFTZ9K80003DHH026MC7JW0/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GAFTZ9K80003DHH026MC7JW0/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GAFTZ9K80003DHH026MC7JW0/4x.webp',
    },
  },
  {
    id: '01GAZ199Z8000FEWHS6AT5QZV0',
    name: 'peepoHappy',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GAZ199Z8000FEWHS6AT5QZV0/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GAZ199Z8000FEWHS6AT5QZV0/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GAZ199Z8000FEWHS6AT5QZV0/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GAZ199Z8000FEWHS6AT5QZV0/4x.webp',
    },
  },
  {
    id: '01GAZ4SBX80007YCE2RXBT44B2',
    name: 'peepoSad',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GAZ4SBX80007YCE2RXBT44B2/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GAZ4SBX80007YCE2RXBT44B2/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GAZ4SBX80007YCE2RXBT44B2/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GAZ4SBX80007YCE2RXBT44B2/4x.webp',
    },
  },
  {
    id: '01GB9W8JN80004CKF2H1TWA99H',
    name: 'FeelsDankMan',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB9W8JN80004CKF2H1TWA99H/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB9W8JN80004CKF2H1TWA99H/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB9W8JN80004CKF2H1TWA99H/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB9W8JN80004CKF2H1TWA99H/4x.webp',
    },
  },
  {
    id: '01GB2S7H7000018VJGJ4A9BMFS',
    name: 'BillyApprove',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB2S7H7000018VJGJ4A9BMFS/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB2S7H7000018VJGJ4A9BMFS/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB2S7H7000018VJGJ4A9BMFS/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB2S7H7000018VJGJ4A9BMFS/4x.webp',
    },
  },
  {
    id: '01GB8EQNJ8000497KFBZWNSDFZ',
    name: 'forsenPls',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB8EQNJ8000497KFBZWNSDFZ/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB8EQNJ8000497KFBZWNSDFZ/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB8EQNJ8000497KFBZWNSDFZ/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB8EQNJ8000497KFBZWNSDFZ/4x.webp',
    },
  },
  {
    id: '01GB54CZTG0004ZBZEDT30HE2M',
    name: 'RoxyPotato',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB54CZTG0004ZBZEDT30HE2M/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB54CZTG0004ZBZEDT30HE2M/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB54CZTG0004ZBZEDT30HE2M/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB54CZTG0004ZBZEDT30HE2M/4x.webp',
    },
  },
  {
    id: '01GB4P2HX0000BJ5HR8F6XV9Q0',
    name: 'gachiBASS',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB4P2HX0000BJ5HR8F6XV9Q0/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB4P2HX0000BJ5HR8F6XV9Q0/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB4P2HX0000BJ5HR8F6XV9Q0/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB4P2HX0000BJ5HR8F6XV9Q0/4x.webp',
    },
  },
  {
    id: '01GKQXGX1R000216YB0K7GN92X',
    name: '(7TV)',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GKQXGX1R000216YB0K7GN92X/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GKQXGX1R000216YB0K7GN92X/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GKQXGX1R000216YB0K7GN92X/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GKQXGX1R000216YB0K7GN92X/4x.webp',
    },
  },
  {
    id: '01FKSDK14G0008TM5NY9QEG0QV',
    name: 'PartyParrot',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01FKSDK14G0008TM5NY9QEG0QV/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01FKSDK14G0008TM5NY9QEG0QV/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01FKSDK14G0008TM5NY9QEG0QV/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01FKSDK14G0008TM5NY9QEG0QV/4x.webp',
    },
  },
  {
    id: '01GB5VC57000003DZTMZQNY944',
    name: 'RebeccaBlack',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB5VC57000003DZTMZQNY944/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB5VC57000003DZTMZQNY944/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB5VC57000003DZTMZQNY944/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB5VC57000003DZTMZQNY944/4x.webp',
    },
  },
  {
    id: '01F014S6KG0007E4VV006YKSM3',
    name: 'reckH',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01F014S6KG0007E4VV006YKSM3/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01F014S6KG0007E4VV006YKSM3/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01F014S6KG0007E4VV006YKSM3/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01F014S6KG0007E4VV006YKSM3/4x.webp',
    },
  },
  {
    id: '01G98W833R0000BRQD106P0ZNT',
    name: 'WAYTOODANK',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01G98W833R0000BRQD106P0ZNT/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01G98W833R0000BRQD106P0ZNT/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01G98W833R0000BRQD106P0ZNT/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01G98W833R0000BRQD106P0ZNT/4x.webp',
    },
  },
  {
    id: '01GB2ZJFBG000DTBJYANG8XYFP',
    name: 'AlienDance',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB2ZJFBG000DTBJYANG8XYFP/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB2ZJFBG000DTBJYANG8XYFP/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB2ZJFBG000DTBJYANG8XYFP/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB2ZJFBG000DTBJYANG8XYFP/4x.webp',
    },
  },
  {
    id: '01G4GQC5H0000D3DGNAYJJP8EB',
    name: 'Gayge',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01G4GQC5H0000D3DGNAYJJP8EB/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01G4GQC5H0000D3DGNAYJJP8EB/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01G4GQC5H0000D3DGNAYJJP8EB/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01G4GQC5H0000D3DGNAYJJP8EB/4x.webp',
    },
  },
  {
    id: '01GGCQPCGR000C7MT8JZGP6E89',
    name: 'ApuApustaja',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GGCQPCGR000C7MT8JZGP6E89/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GGCQPCGR000C7MT8JZGP6E89/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GGCQPCGR000C7MT8JZGP6E89/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GGCQPCGR000C7MT8JZGP6E89/4x.webp',
    },
  },
  {
    id: '01GB9W2CDG000BFSD141G0MGSA',
    name: 'BasedGod',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB9W2CDG000BFSD141G0MGSA/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB9W2CDG000BFSD141G0MGSA/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB9W2CDG000BFSD141G0MGSA/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB9W2CDG000BFSD141G0MGSA/4x.webp',
    },
  },
  {
    id: '01G98V5RFG0001CD052SPS435F',
    name: 'GuitarTime',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01G98V5RFG0001CD052SPS435F/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01G98V5RFG0001CD052SPS435F/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01G98V5RFG0001CD052SPS435F/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01G98V5RFG0001CD052SPS435F/4x.webp',
    },
  },
  {
    id: '01HM524VE80004SKSHMCZWXH1T',
    name: 'peepoPls',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01HM524VE80004SKSHMCZWXH1T/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01HM524VE80004SKSHMCZWXH1T/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01HM524VE80004SKSHMCZWXH1T/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01HM524VE80004SKSHMCZWXH1T/4x.webp',
    },
  },
  {
    id: '01HM4P26CR000449DZBT4FVMA5',
    name: 'TeaTime',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01HM4P26CR000449DZBT4FVMA5/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01HM4P26CR000449DZBT4FVMA5/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01HM4P26CR000449DZBT4FVMA5/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01HM4P26CR000449DZBT4FVMA5/4x.webp',
    },
  },
  {
    id: '01HM4PGHC80007635TAZG67FT5',
    name: 'WineTime',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01HM4PGHC80007635TAZG67FT5/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01HM4PGHC80007635TAZG67FT5/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01HM4PGHC80007635TAZG67FT5/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01HM4PGHC80007635TAZG67FT5/4x.webp',
    },
  },
  {
    id: '01G98V81Q80000BRQD106P0ZEK',
    name: 'PianoTime',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01G98V81Q80000BRQD106P0ZEK/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01G98V81Q80000BRQD106P0ZEK/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01G98V81Q80000BRQD106P0ZEK/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01G98V81Q80000BRQD106P0ZEK/4x.webp',
    },
  },
  {
    id: '01G98TT6BR000A39K5ZSQFTPWR',
    name: 'CrayonTime',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01G98TT6BR000A39K5ZSQFTPWR/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01G98TT6BR000A39K5ZSQFTPWR/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01G98TT6BR000A39K5ZSQFTPWR/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01G98TT6BR000A39K5ZSQFTPWR/4x.webp',
    },
  },
  {
    id: '01HM6NJ2X000035ZKVAPWBNW26',
    name: 'nymnCorn',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01HM6NJ2X000035ZKVAPWBNW26/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01HM6NJ2X000035ZKVAPWBNW26/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01HM6NJ2X000035ZKVAPWBNW26/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01HM6NJ2X000035ZKVAPWBNW26/4x.webp',
    },
  },
  {
    id: '01HM2F7Q1R00022X3E2804NBNQ',
    name: 'SteerR',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01HM2F7Q1R00022X3E2804NBNQ/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01HM2F7Q1R00022X3E2804NBNQ/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01HM2F7Q1R00022X3E2804NBNQ/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01HM2F7Q1R00022X3E2804NBNQ/4x.webp',
    },
  },
  {
    id: '01J107C3E8000DX4MZBQSYGRXS',
    name: 'sevenTV',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01J107C3E8000DX4MZBQSYGRXS/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01J107C3E8000DX4MZBQSYGRXS/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01J107C3E8000DX4MZBQSYGRXS/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01J107C3E8000DX4MZBQSYGRXS/4x.webp',
    },
  },
  {
    id: '01FTEZEE900001E12995B12GR4',
    name: 'nanaAYAYA',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01FTEZEE900001E12995B12GR4/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01FTEZEE900001E12995B12GR4/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01FTEZEE900001E12995B12GR4/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01FTEZEE900001E12995B12GR4/4x.webp',
    },
  },
  {
    id: '01J8NMZ2HG0005G1FWF2H9Y615',
    name: 'BibleThump',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01J8NMZ2HG0005G1FWF2H9Y615/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01J8NMZ2HG0005G1FWF2H9Y615/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01J8NMZ2HG0005G1FWF2H9Y615/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01J8NMZ2HG0005G1FWF2H9Y615/4x.webp',
    },
  },
  {
    id: '01H16FA16G0005EZED5J0EY7KN',
    name: 'glorp',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01H16FA16G0005EZED5J0EY7KN/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01H16FA16G0005EZED5J0EY7KN/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01H16FA16G0005EZED5J0EY7KN/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01H16FA16G0005EZED5J0EY7KN/4x.webp',
    },
  },
  {
    id: '01GG3YGWK8000DWE419062SG28',
    name: 'Stare',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GG3YGWK8000DWE419062SG28/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GG3YGWK8000DWE419062SG28/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GG3YGWK8000DWE419062SG28/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GG3YGWK8000DWE419062SG28/4x.webp',
    },
  },
  {
    id: '01JY2MX5BE5BVWWFV153ANMMHZ',
    name: 'aceStare',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01JY2MX5BE5BVWWFV153ANMMHZ/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01JY2MX5BE5BVWWFV153ANMMHZ/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01JY2MX5BE5BVWWFV153ANMMHZ/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01JY2MX5BE5BVWWFV153ANMMHZ/4x.webp',
    },
  },
  {
    id: '01F9EM2ETG000E7SC8F953GXCX',
    name: 'gachiGASM',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01F9EM2ETG000E7SC8F953GXCX/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01F9EM2ETG000E7SC8F953GXCX/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01F9EM2ETG000E7SC8F953GXCX/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01F9EM2ETG000E7SC8F953GXCX/4x.webp',
    },
  },
  {
    id: '01GB32XE6R00018VJGJ4A9BNCV',
    name: 'AYAYA',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB32XE6R00018VJGJ4A9BNCV/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB32XE6R00018VJGJ4A9BNCV/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB32XE6R00018VJGJ4A9BNCV/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB32XE6R00018VJGJ4A9BNCV/4x.webp',
    },
  },
  {
    id: '01GB4XE3ZR000DKFRGM9Q1M7VS',
    name: 'RareParrot',
    platform: '7tv',
    animated: true,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB4XE3ZR000DKFRGM9Q1M7VS/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB4XE3ZR000DKFRGM9Q1M7VS/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB4XE3ZR000DKFRGM9Q1M7VS/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB4XE3ZR000DKFRGM9Q1M7VS/4x.webp',
    },
  },
  {
    id: '01GB4FWTR8000DGEZ8VYY59RBN',
    name: 'FeelsWeirdMan',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB4FWTR8000DGEZ8VYY59RBN/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB4FWTR8000DGEZ8VYY59RBN/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB4FWTR8000DGEZ8VYY59RBN/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB4FWTR8000DGEZ8VYY59RBN/4x.webp',
    },
  },
  {
    id: '01GB4CK01800090V9B3D8CGEEX',
    name: 'EZ',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB4CK01800090V9B3D8CGEEX/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB4CK01800090V9B3D8CGEEX/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB4CK01800090V9B3D8CGEEX/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB4CK01800090V9B3D8CGEEX/4x.webp',
    },
  },
  {
    id: '01GB46137R000BJ5HR8F6XV8J1',
    name: 'FeelsOkayMan',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB46137R000BJ5HR8F6XV8J1/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB46137R000BJ5HR8F6XV8J1/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB46137R000BJ5HR8F6XV8J1/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB46137R000BJ5HR8F6XV8J1/4x.webp',
    },
  },
  {
    id: '01GB4EV0Q800090V9B3D8CGEHV',
    name: 'FeelsStrongMan',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GB4EV0Q800090V9B3D8CGEHV/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GB4EV0Q800090V9B3D8CGEHV/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GB4EV0Q800090V9B3D8CGEHV/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GB4EV0Q800090V9B3D8CGEHV/4x.webp',
    },
  },
  {
    id: '01GBFDVP18000CRDCG0DV7KEMY',
    name: '7Cinema',
    platform: '7tv',
    animated: false,
    urls: {
      '1': 'https://cdn.7tv.app/emote/01GBFDVP18000CRDCG0DV7KEMY/1x.webp',
      '2': 'https://cdn.7tv.app/emote/01GBFDVP18000CRDCG0DV7KEMY/2x.webp',
      '3': 'https://cdn.7tv.app/emote/01GBFDVP18000CRDCG0DV7KEMY/3x.webp',
      '4': 'https://cdn.7tv.app/emote/01GBFDVP18000CRDCG0DV7KEMY/4x.webp',
    },
  },
];

const BttvEmotes = [
  {
    id: '54fa8f1401e468494b85b537',
    name: ':tf:',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa8f1401e468494b85b537/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa8f1401e468494b85b537/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa8f1401e468494b85b537/3x',
    },
  },
  {
    id: '54fa8fce01e468494b85b53c',
    name: 'CiGrip',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa8fce01e468494b85b53c/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa8fce01e468494b85b53c/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa8fce01e468494b85b53c/3x',
    },
  },
  {
    id: '54fa903b01e468494b85b53f',
    name: 'DatSauce',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa903b01e468494b85b53f/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa903b01e468494b85b53f/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa903b01e468494b85b53f/3x',
    },
  },
  {
    id: '54fa909b01e468494b85b542',
    name: 'ForeverAlone',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa909b01e468494b85b542/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa909b01e468494b85b542/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa909b01e468494b85b542/3x',
    },
  },
  {
    id: '54fa90ba01e468494b85b543',
    name: 'GabeN',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa90ba01e468494b85b543/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa90ba01e468494b85b543/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa90ba01e468494b85b543/3x',
    },
  },
  {
    id: '54fa90f201e468494b85b545',
    name: 'HailHelix',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa90f201e468494b85b545/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa90f201e468494b85b545/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa90f201e468494b85b545/3x',
    },
  },
  {
    id: '54fa932201e468494b85b555',
    name: 'ShoopDaWhoop',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa932201e468494b85b555/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa932201e468494b85b555/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa932201e468494b85b555/3x',
    },
  },
  {
    id: '54fab45f633595ca4c713abc',
    name: 'M&Mjc',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fab45f633595ca4c713abc/1x',
      '2': 'https://cdn.betterttv.net/emote/54fab45f633595ca4c713abc/2x',
      '4': 'https://cdn.betterttv.net/emote/54fab45f633595ca4c713abc/3x',
    },
  },
  {
    id: '54fab7d2633595ca4c713abf',
    name: 'bttvNice',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fab7d2633595ca4c713abf/1x',
      '2': 'https://cdn.betterttv.net/emote/54fab7d2633595ca4c713abf/2x',
      '4': 'https://cdn.betterttv.net/emote/54fab7d2633595ca4c713abf/3x',
    },
  },
  {
    id: '54fa935601e468494b85b557',
    name: 'TwaT',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa935601e468494b85b557/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa935601e468494b85b557/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa935601e468494b85b557/3x',
    },
  },
  {
    id: '54fa99b601e468494b85b55d',
    name: 'WatChuSay',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fa99b601e468494b85b55d/1x',
      '2': 'https://cdn.betterttv.net/emote/54fa99b601e468494b85b55d/2x',
      '4': 'https://cdn.betterttv.net/emote/54fa99b601e468494b85b55d/3x',
    },
  },
  {
    id: '566ca11a65dbbdab32ec0558',
    name: 'tehPoleCat',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca11a65dbbdab32ec0558/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca11a65dbbdab32ec0558/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca11a65dbbdab32ec0558/3x',
    },
  },
  {
    id: '566ca1a365dbbdab32ec055b',
    name: 'AngelThump',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca1a365dbbdab32ec055b/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca1a365dbbdab32ec055b/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca1a365dbbdab32ec055b/3x',
    },
  },
  {
    id: '54fbefeb01abde735115de5b',
    name: 'TaxiBro',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fbefeb01abde735115de5b/1x',
      '2': 'https://cdn.betterttv.net/emote/54fbefeb01abde735115de5b/2x',
      '4': 'https://cdn.betterttv.net/emote/54fbefeb01abde735115de5b/3x',
    },
  },
  {
    id: '54fbf00a01abde735115de5c',
    name: 'BroBalt',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fbf00a01abde735115de5c/1x',
      '2': 'https://cdn.betterttv.net/emote/54fbf00a01abde735115de5c/2x',
      '4': 'https://cdn.betterttv.net/emote/54fbf00a01abde735115de5c/3x',
    },
  },
  {
    id: '54fbf09c01abde735115de61',
    name: 'CandianRage',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/54fbf09c01abde735115de61/1x',
      '2': 'https://cdn.betterttv.net/emote/54fbf09c01abde735115de61/2x',
      '4': 'https://cdn.betterttv.net/emote/54fbf09c01abde735115de61/3x',
    },
  },
  {
    id: '55028cd2135896936880fdd7',
    name: 'D:',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/55028cd2135896936880fdd7/1x',
      '2': 'https://cdn.betterttv.net/emote/55028cd2135896936880fdd7/2x',
      '4': 'https://cdn.betterttv.net/emote/55028cd2135896936880fdd7/3x',
    },
  },
  {
    id: '550352766f86a5b26c281ba2',
    name: 'VisLaud',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/550352766f86a5b26c281ba2/1x',
      '2': 'https://cdn.betterttv.net/emote/550352766f86a5b26c281ba2/2x',
      '4': 'https://cdn.betterttv.net/emote/550352766f86a5b26c281ba2/3x',
    },
  },
  {
    id: '550b344bff8ecee922d2a3c1',
    name: 'KaRappa',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/550b344bff8ecee922d2a3c1/1x',
      '2': 'https://cdn.betterttv.net/emote/550b344bff8ecee922d2a3c1/2x',
      '4': 'https://cdn.betterttv.net/emote/550b344bff8ecee922d2a3c1/3x',
    },
  },
  {
    id: '566ca00f65dbbdab32ec0544',
    name: 'FishMoley',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca00f65dbbdab32ec0544/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca00f65dbbdab32ec0544/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca00f65dbbdab32ec0544/3x',
    },
  },
  {
    id: '566ca02865dbbdab32ec0547',
    name: 'Hhhehehe',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca02865dbbdab32ec0547/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca02865dbbdab32ec0547/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca02865dbbdab32ec0547/3x',
    },
  },
  {
    id: '566ca04265dbbdab32ec054a',
    name: 'KKona',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca04265dbbdab32ec054a/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca04265dbbdab32ec054a/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca04265dbbdab32ec054a/3x',
    },
  },
  {
    id: '566ca09365dbbdab32ec0555',
    name: 'PoleDoge',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca09365dbbdab32ec0555/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca09365dbbdab32ec0555/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca09365dbbdab32ec0555/3x',
    },
  },
  {
    id: '553b48a21f145f087fc15ca6',
    name: 'sosGame',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/553b48a21f145f087fc15ca6/1x',
      '2': 'https://cdn.betterttv.net/emote/553b48a21f145f087fc15ca6/2x',
      '4': 'https://cdn.betterttv.net/emote/553b48a21f145f087fc15ca6/3x',
    },
  },
  {
    id: '55471c2789d53f2d12781713',
    name: 'CruW',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/55471c2789d53f2d12781713/1x',
      '2': 'https://cdn.betterttv.net/emote/55471c2789d53f2d12781713/2x',
      '4': 'https://cdn.betterttv.net/emote/55471c2789d53f2d12781713/3x',
    },
  },
  {
    id: '555015b77676617e17dd2e8e',
    name: 'RarePepe',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/555015b77676617e17dd2e8e/1x',
      '2': 'https://cdn.betterttv.net/emote/555015b77676617e17dd2e8e/2x',
      '4': 'https://cdn.betterttv.net/emote/555015b77676617e17dd2e8e/3x',
    },
  },
  {
    id: '555981336ba1901877765555',
    name: 'haHAA',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/555981336ba1901877765555/1x',
      '2': 'https://cdn.betterttv.net/emote/555981336ba1901877765555/2x',
      '4': 'https://cdn.betterttv.net/emote/555981336ba1901877765555/3x',
    },
  },
  {
    id: '55b6524154eefd53777b2580',
    name: 'FeelsBirthdayMan',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/55b6524154eefd53777b2580/1x',
      '2': 'https://cdn.betterttv.net/emote/55b6524154eefd53777b2580/2x',
      '4': 'https://cdn.betterttv.net/emote/55b6524154eefd53777b2580/3x',
    },
  },
  {
    id: '55f324c47f08be9f0a63cce0',
    name: 'RonSmug',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/55f324c47f08be9f0a63cce0/1x',
      '2': 'https://cdn.betterttv.net/emote/55f324c47f08be9f0a63cce0/2x',
      '4': 'https://cdn.betterttv.net/emote/55f324c47f08be9f0a63cce0/3x',
    },
  },
  {
    id: '560577560874de34757d2dc0',
    name: 'KappaCool',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/560577560874de34757d2dc0/1x',
      '2': 'https://cdn.betterttv.net/emote/560577560874de34757d2dc0/2x',
      '4': 'https://cdn.betterttv.net/emote/560577560874de34757d2dc0/3x',
    },
  },
  {
    id: '566c9fc265dbbdab32ec053b',
    name: 'FeelsBadMan',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566c9fc265dbbdab32ec053b/1x',
      '2': 'https://cdn.betterttv.net/emote/566c9fc265dbbdab32ec053b/2x',
      '4': 'https://cdn.betterttv.net/emote/566c9fc265dbbdab32ec053b/3x',
    },
  },
  {
    id: '566c9f3b65dbbdab32ec052e',
    name: 'bUrself',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566c9f3b65dbbdab32ec052e/1x',
      '2': 'https://cdn.betterttv.net/emote/566c9f3b65dbbdab32ec052e/2x',
      '4': 'https://cdn.betterttv.net/emote/566c9f3b65dbbdab32ec052e/3x',
    },
  },
  {
    id: '566c9f6365dbbdab32ec0532',
    name: 'ConcernDoge',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566c9f6365dbbdab32ec0532/1x',
      '2': 'https://cdn.betterttv.net/emote/566c9f6365dbbdab32ec0532/2x',
      '4': 'https://cdn.betterttv.net/emote/566c9f6365dbbdab32ec0532/3x',
    },
  },
  {
    id: '566c9fde65dbbdab32ec053e',
    name: 'FeelsGoodMan',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566c9fde65dbbdab32ec053e/1x',
      '2': 'https://cdn.betterttv.net/emote/566c9fde65dbbdab32ec053e/2x',
      '4': 'https://cdn.betterttv.net/emote/566c9fde65dbbdab32ec053e/3x',
    },
  },
  {
    id: '566c9ff365dbbdab32ec0541',
    name: 'FireSpeed',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566c9ff365dbbdab32ec0541/1x',
      '2': 'https://cdn.betterttv.net/emote/566c9ff365dbbdab32ec0541/2x',
      '4': 'https://cdn.betterttv.net/emote/566c9ff365dbbdab32ec0541/3x',
    },
  },
  {
    id: '566ca06065dbbdab32ec054e',
    name: 'NaM',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca06065dbbdab32ec054e/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca06065dbbdab32ec054e/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca06065dbbdab32ec054e/3x',
    },
  },
  {
    id: '566ca38765dbbdab32ec0560',
    name: 'SourPls',
    platform: 'bttv',
    animated: true,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566ca38765dbbdab32ec0560/1x',
      '2': 'https://cdn.betterttv.net/emote/566ca38765dbbdab32ec0560/2x',
      '4': 'https://cdn.betterttv.net/emote/566ca38765dbbdab32ec0560/3x',
    },
  },
  {
    id: '566dde0e65dbbdab32ec068f',
    name: 'FeelsSnowMan',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566dde0e65dbbdab32ec068f/1x',
      '2': 'https://cdn.betterttv.net/emote/566dde0e65dbbdab32ec068f/2x',
      '4': 'https://cdn.betterttv.net/emote/566dde0e65dbbdab32ec068f/3x',
    },
  },
  {
    id: '566decae65dbbdab32ec0699',
    name: 'FeelsSnowyMan',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/566decae65dbbdab32ec0699/1x',
      '2': 'https://cdn.betterttv.net/emote/566decae65dbbdab32ec0699/2x',
      '4': 'https://cdn.betterttv.net/emote/566decae65dbbdab32ec0699/3x',
    },
  },
  {
    id: '567b00c61ddbe1786688a633',
    name: 'LuL',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/567b00c61ddbe1786688a633/1x',
      '2': 'https://cdn.betterttv.net/emote/567b00c61ddbe1786688a633/2x',
      '4': 'https://cdn.betterttv.net/emote/567b00c61ddbe1786688a633/3x',
    },
  },
  {
    id: '56901914991f200c34ffa656',
    name: 'SaltyCorn',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/56901914991f200c34ffa656/1x',
      '2': 'https://cdn.betterttv.net/emote/56901914991f200c34ffa656/2x',
      '4': 'https://cdn.betterttv.net/emote/56901914991f200c34ffa656/3x',
    },
  },
  {
    id: '56e9f494fff3cc5c35e5287e',
    name: 'monkaS',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/56e9f494fff3cc5c35e5287e/1x',
      '2': 'https://cdn.betterttv.net/emote/56e9f494fff3cc5c35e5287e/2x',
      '4': 'https://cdn.betterttv.net/emote/56e9f494fff3cc5c35e5287e/3x',
    },
  },
  {
    id: '56f5be00d48006ba34f530a4',
    name: 'VapeNation',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/56f5be00d48006ba34f530a4/1x',
      '2': 'https://cdn.betterttv.net/emote/56f5be00d48006ba34f530a4/2x',
      '4': 'https://cdn.betterttv.net/emote/56f5be00d48006ba34f530a4/3x',
    },
  },
  {
    id: '56fa09f18eff3b595e93ac26',
    name: 'ariW',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/56fa09f18eff3b595e93ac26/1x',
      '2': 'https://cdn.betterttv.net/emote/56fa09f18eff3b595e93ac26/2x',
      '4': 'https://cdn.betterttv.net/emote/56fa09f18eff3b595e93ac26/3x',
    },
  },
  {
    id: '5709ab688eff3b595e93c595',
    name: 'notsquishY',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5709ab688eff3b595e93c595/1x',
      '2': 'https://cdn.betterttv.net/emote/5709ab688eff3b595e93c595/2x',
      '4': 'https://cdn.betterttv.net/emote/5709ab688eff3b595e93c595/3x',
    },
  },
  {
    id: '5733ff12e72c3c0814233e20',
    name: 'FeelsAmazingMan',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5733ff12e72c3c0814233e20/1x',
      '2': 'https://cdn.betterttv.net/emote/5733ff12e72c3c0814233e20/2x',
      '4': 'https://cdn.betterttv.net/emote/5733ff12e72c3c0814233e20/3x',
    },
  },
  {
    id: '573d38b50ffbf6cc5cc38dc9',
    name: 'DuckerZ',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/573d38b50ffbf6cc5cc38dc9/1x',
      '2': 'https://cdn.betterttv.net/emote/573d38b50ffbf6cc5cc38dc9/2x',
      '4': 'https://cdn.betterttv.net/emote/573d38b50ffbf6cc5cc38dc9/3x',
    },
  },
  {
    id: '580e438942170bfd57189866',
    name: 'FeelsPumpkinMan',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/580e438942170bfd57189866/1x',
      '2': 'https://cdn.betterttv.net/emote/580e438942170bfd57189866/2x',
      '4': 'https://cdn.betterttv.net/emote/580e438942170bfd57189866/3x',
    },
  },
  {
    id: '59cf182fcbe2693d59d7bf46',
    name: 'SqShy',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/59cf182fcbe2693d59d7bf46/1x',
      '2': 'https://cdn.betterttv.net/emote/59cf182fcbe2693d59d7bf46/2x',
      '4': 'https://cdn.betterttv.net/emote/59cf182fcbe2693d59d7bf46/3x',
    },
  },
  {
    id: '58d2e73058d8950a875ad027',
    name: 'Wowee',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/58d2e73058d8950a875ad027/1x',
      '2': 'https://cdn.betterttv.net/emote/58d2e73058d8950a875ad027/2x',
      '4': 'https://cdn.betterttv.net/emote/58d2e73058d8950a875ad027/3x',
    },
  },
  {
    id: '5dc36a8db537d747e37ac187',
    name: 'WubTF',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5dc36a8db537d747e37ac187/1x',
      '2': 'https://cdn.betterttv.net/emote/5dc36a8db537d747e37ac187/2x',
      '4': 'https://cdn.betterttv.net/emote/5dc36a8db537d747e37ac187/3x',
    },
  },
  {
    id: '5e76d2ab8c0f5c3723a9a87d',
    name: 'cvR',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5e76d2ab8c0f5c3723a9a87d/1x',
      '2': 'https://cdn.betterttv.net/emote/5e76d2ab8c0f5c3723a9a87d/2x',
      '4': 'https://cdn.betterttv.net/emote/5e76d2ab8c0f5c3723a9a87d/3x',
    },
  },
  {
    id: '5e76d2d2d112fc372574d222',
    name: 'cvL',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5e76d2d2d112fc372574d222/1x',
      '2': 'https://cdn.betterttv.net/emote/5e76d2d2d112fc372574d222/2x',
      '4': 'https://cdn.betterttv.net/emote/5e76d2d2d112fc372574d222/3x',
    },
  },
  {
    id: '5e76d338d6581c3724c0f0b2',
    name: 'cvHazmat',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5e76d338d6581c3724c0f0b2/1x',
      '2': 'https://cdn.betterttv.net/emote/5e76d338d6581c3724c0f0b2/2x',
      '4': 'https://cdn.betterttv.net/emote/5e76d338d6581c3724c0f0b2/3x',
    },
  },
  {
    id: '5e76d399d6581c3724c0f0b8',
    name: 'cvMask',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5e76d399d6581c3724c0f0b8/1x',
      '2': 'https://cdn.betterttv.net/emote/5e76d399d6581c3724c0f0b8/2x',
      '4': 'https://cdn.betterttv.net/emote/5e76d399d6581c3724c0f0b8/3x',
    },
  },
  {
    id: '5ffdf28dc96152314ad63960',
    name: 'DogChamp',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/5ffdf28dc96152314ad63960/1x',
      '2': 'https://cdn.betterttv.net/emote/5ffdf28dc96152314ad63960/2x',
      '4': 'https://cdn.betterttv.net/emote/5ffdf28dc96152314ad63960/3x',
    },
  },
  {
    id: '6468f7acaee1f7f47567708e',
    name: 'c!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/6468f7acaee1f7f47567708e/1x',
      '2': 'https://cdn.betterttv.net/emote/6468f7acaee1f7f47567708e/2x',
      '4': 'https://cdn.betterttv.net/emote/6468f7acaee1f7f47567708e/3x',
    },
  },
  {
    id: '6468f845aee1f7f47567709b',
    name: 'h!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/6468f845aee1f7f47567709b/1x',
      '2': 'https://cdn.betterttv.net/emote/6468f845aee1f7f47567709b/2x',
      '4': 'https://cdn.betterttv.net/emote/6468f845aee1f7f47567709b/3x',
    },
  },
  {
    id: '6468f869aee1f7f4756770a8',
    name: 'l!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/6468f869aee1f7f4756770a8/1x',
      '2': 'https://cdn.betterttv.net/emote/6468f869aee1f7f4756770a8/2x',
      '4': 'https://cdn.betterttv.net/emote/6468f869aee1f7f4756770a8/3x',
    },
  },
  {
    id: '6468f883aee1f7f4756770b5',
    name: 'r!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/6468f883aee1f7f4756770b5/1x',
      '2': 'https://cdn.betterttv.net/emote/6468f883aee1f7f4756770b5/2x',
      '4': 'https://cdn.betterttv.net/emote/6468f883aee1f7f4756770b5/3x',
    },
  },
  {
    id: '6468f89caee1f7f4756770c2',
    name: 'v!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/6468f89caee1f7f4756770c2/1x',
      '2': 'https://cdn.betterttv.net/emote/6468f89caee1f7f4756770c2/2x',
      '4': 'https://cdn.betterttv.net/emote/6468f89caee1f7f4756770c2/3x',
    },
  },
  {
    id: '6468f8d1aee1f7f4756770cf',
    name: 'z!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/6468f8d1aee1f7f4756770cf/1x',
      '2': 'https://cdn.betterttv.net/emote/6468f8d1aee1f7f4756770cf/2x',
      '4': 'https://cdn.betterttv.net/emote/6468f8d1aee1f7f4756770cf/3x',
    },
  },
  {
    id: '64e3b31920cb0d25d950a9f9',
    name: 'w!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/64e3b31920cb0d25d950a9f9/1x',
      '2': 'https://cdn.betterttv.net/emote/64e3b31920cb0d25d950a9f9/2x',
      '4': 'https://cdn.betterttv.net/emote/64e3b31920cb0d25d950a9f9/3x',
    },
  },
  {
    id: '65cbe7dbaed093b2eaf87c65',
    name: 'p!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/65cbe7dbaed093b2eaf87c65/1x',
      '2': 'https://cdn.betterttv.net/emote/65cbe7dbaed093b2eaf87c65/2x',
      '4': 'https://cdn.betterttv.net/emote/65cbe7dbaed093b2eaf87c65/3x',
    },
  },
  {
    id: '662953eeea369c0ece39eb93',
    name: 's!',
    platform: 'bttv',
    animated: false,
    urls: {
      '1': 'https://cdn.betterttv.net/emote/662953eeea369c0ece39eb93/1x',
      '2': 'https://cdn.betterttv.net/emote/662953eeea369c0ece39eb93/2x',
      '4': 'https://cdn.betterttv.net/emote/662953eeea369c0ece39eb93/3x',
    },
  },
];

const FfzEmotes = [
  {
    id: '9',
    name: 'ZrehplaR',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/9/1',
      '2': 'https://cdn.frankerfacez.com/emote/9/2',
      '4': 'https://cdn.frankerfacez.com/emote/9/4',
    },
  },
  {
    id: '6',
    name: 'YooHoo',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/6/1',
      '2': 'https://cdn.frankerfacez.com/emote/6/2',
      '4': 'https://cdn.frankerfacez.com/emote/6/4',
    },
  },
  {
    id: '4',
    name: 'ManChicken',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/4/1',
      '2': 'https://cdn.frankerfacez.com/emote/4/2',
      '4': 'https://cdn.frankerfacez.com/emote/4/4',
    },
  },
  {
    id: '3',
    name: 'BeanieHipster',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/3/1',
      '2': 'https://cdn.frankerfacez.com/emote/3/2',
      '4': 'https://cdn.frankerfacez.com/emote/3/4',
    },
  },
  {
    id: '25927',
    name: 'CatBag',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/25927/1',
      '2': 'https://cdn.frankerfacez.com/emote/25927/2',
      '4': 'https://cdn.frankerfacez.com/emote/25927/4',
    },
  },
  {
    id: '27081',
    name: 'ZreknarF',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/27081/1',
      '2': 'https://cdn.frankerfacez.com/emote/27081/2',
      '4': 'https://cdn.frankerfacez.com/emote/27081/4',
    },
  },
  {
    id: '28136',
    name: 'LilZ',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/28136/1',
      '2': 'https://cdn.frankerfacez.com/emote/28136/2',
      '4': 'https://cdn.frankerfacez.com/emote/28136/4',
    },
  },
  {
    id: '28138',
    name: 'ZliL',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/28138/1',
      '2': 'https://cdn.frankerfacez.com/emote/28138/2',
      '4': 'https://cdn.frankerfacez.com/emote/28138/4',
    },
  },
  {
    id: '149346',
    name: 'LaterSooner',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/149346/1',
      '2': 'https://cdn.frankerfacez.com/emote/149346/2',
      '4': 'https://cdn.frankerfacez.com/emote/149346/4',
    },
  },
  {
    id: '142673',
    name: 'BORT',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/142673/1',
      '2': 'https://cdn.frankerfacez.com/emote/142673/2',
      '4': 'https://cdn.frankerfacez.com/emote/142673/4',
    },
  },
  {
    id: '757384',
    name: 'BibleThump',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/757384/1',
      '2': 'https://cdn.frankerfacez.com/emote/757384/2',
      '4': 'https://cdn.frankerfacez.com/emote/757384/4',
    },
  },
  {
    id: '723890',
    name: 'ffzW',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/723890/1',
      '2': 'https://cdn.frankerfacez.com/emote/723890/2',
      '4': 'https://cdn.frankerfacez.com/emote/723890/4',
    },
  },
  {
    id: '720508',
    name: 'ffzX',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/720508/1',
      '2': 'https://cdn.frankerfacez.com/emote/720508/2',
      '4': 'https://cdn.frankerfacez.com/emote/720508/4',
    },
  },
  {
    id: '720509',
    name: 'ffzY',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/720509/1',
      '2': 'https://cdn.frankerfacez.com/emote/720509/2',
      '4': 'https://cdn.frankerfacez.com/emote/720509/4',
    },
  },
  {
    id: '720729',
    name: 'ffzCursed',
    platform: 'ffz',
    animated: false,
    urls: {
      '1': 'https://cdn.frankerfacez.com/emote/720729/1',
      '2': 'https://cdn.frankerfacez.com/emote/720729/2',
      '4': 'https://cdn.frankerfacez.com/emote/720729/4',
    },
  },
];

const TwitchEmotes = [
  {
    type: 'twitch',
    name: 'AsexualPride',
    id: '307827267',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/307827267/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/307827267/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/307827267/static/dark/3.0',
    },
    start: 0,
    end: 12,
  },
  {
    type: 'twitch',
    name: 'BisexualPride',
    id: '307827313',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/307827313/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/307827313/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/307827313/static/dark/3.0',
    },
    start: 13,
    end: 26,
  },
  {
    type: 'twitch',
    name: 'GayPride',
    id: '307827321',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/307827321/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/307827321/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/307827321/static/dark/3.0',
    },
    start: 27,
    end: 35,
  },
  {
    type: 'twitch',
    name: 'GenderFluidPride',
    id: '307827326',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/307827326/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/307827326/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/307827326/static/dark/3.0',
    },
    start: 36,
    end: 52,
  },
  {
    type: 'twitch',
    name: 'IntersexPride',
    id: '307827332',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/307827332/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/307827332/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/307827332/static/dark/3.0',
    },
    start: 53,
    end: 66,
  },
  {
    type: 'twitch',
    name: 'KappaPride',
    id: '55338',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/55338/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/55338/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/55338/static/dark/3.0',
    },
    start: 67,
    end: 77,
  },
  {
    type: 'twitch',
    name: 'PansexualPride',
    id: '307827370',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/307827370/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/307827370/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/307827370/static/dark/3.0',
    },
    start: 78,
    end: 92,
  },
  {
    type: 'twitch',
    name: 'TransgenderPride',
    id: '307827377',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/307827377/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/307827377/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/307827377/static/dark/3.0',
    },
    start: 93,
    end: 109,
  },
  {
    type: 'twitch',
    name: 'TheIlluminati',
    id: '145315',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/145315/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/145315/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/145315/static/dark/3.0',
    },
    start: 110,
    end: 123,
  },
  {
    type: 'twitch',
    name: 'BrainSlug',
    id: '115233',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/115233/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/115233/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/115233/static/dark/3.0',
    },
    start: 124,
    end: 133,
  },
  {
    type: 'twitch',
    name: 'imGlitch',
    id: '112290',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/112290/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/112290/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/112290/static/dark/3.0',
    },
    start: 134,
    end: 142,
  },
  {
    type: 'twitch',
    name: 'GlitchNRG',
    id: '304489309',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/304489309/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/304489309/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/304489309/static/dark/3.0',
    },
    start: 143,
    end: 152,
  },
  {
    type: 'twitch',
    name: 'TakeNRG',
    id: '112292',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/112292/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/112292/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/112292/static/dark/3.0',
    },
    start: 153,
    end: 160,
  },
  {
    type: 'twitch',
    name: 'DxCat',
    id: '110734',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/110734/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/110734/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/110734/static/dark/3.0',
    },
    start: 161,
    end: 166,
  },
  {
    type: 'twitch',
    name: 'VoHiYo',
    id: '81274',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/81274/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/81274/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/81274/static/dark/3.0',
    },
    start: 167,
    end: 173,
  },
  {
    type: 'twitch',
    name: 'DoritosChip',
    id: '102242',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/102242/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/102242/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/102242/static/dark/3.0',
    },
    start: 174,
    end: 185,
  },
  {
    type: 'twitch',
    name: 'KomodoHype',
    id: '81273',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/81273/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/81273/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/81273/static/dark/3.0',
    },
    start: 186,
    end: 196,
  },
  {
    type: 'twitch',
    name: 'duDudu',
    id: '62834',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/62834/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/62834/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/62834/static/dark/3.0',
    },
    start: 197,
    end: 203,
  },
  {
    type: 'twitch',
    name: 'CoolCat',
    id: '58127',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/58127/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/58127/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/58127/static/dark/3.0',
    },
    start: 204,
    end: 211,
  },
  {
    type: 'twitch',
    name: 'BloodTrail',
    id: '69',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/69/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/69/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/69/static/dark/3.0',
    },
    start: 212,
    end: 222,
  },
  {
    type: 'twitch',
    name: 'PunchTrees',
    id: '47',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/47/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/47/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/47/static/dark/3.0',
    },
    start: 223,
    end: 233,
  },
  {
    type: 'twitch',
    name: 'SSSsss',
    id: '46',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/46/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/46/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/46/static/dark/3.0',
    },
    start: 234,
    end: 240,
  },
  {
    type: 'twitch',
    name: 'SSSsssplode',
    id: 'emotesv2_df1b3a19d9fc4bff81429afdfb46fff0',
    gif: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_df1b3a19d9fc4bff81429afdfb46fff0/default/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_df1b3a19d9fc4bff81429afdfb46fff0/default/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_df1b3a19d9fc4bff81429afdfb46fff0/default/dark/3.0',
    },
    start: 241,
    end: 251,
  },
  {
    type: 'twitch',
    name: 'Kappa',
    id: '25',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/25/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/25/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/25/static/dark/3.0',
    },
    start: 253,
    end: 258,
  },
  {
    type: 'twitch',
    name: 'KappaClaus',
    id: '74510',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/74510/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/74510/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/74510/static/dark/3.0',
    },
    start: 259,
    end: 269,
  },
  {
    type: 'twitch',
    name: 'MrDestructoid',
    id: '28',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/28/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/28/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/28/static/dark/3.0',
    },
    start: 270,
    end: 283,
  },
  {
    type: 'twitch',
    name: 'HSWP',
    id: '446979',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/446979/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/446979/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/446979/static/dark/3.0',
    },
    start: 292,
    end: 296,
  },
  {
    type: 'twitch',
    name: 'Shush',
    id: 'emotesv2_819621bcb8f44566a1bd8ea63d06c58f',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_819621bcb8f44566a1bd8ea63d06c58f/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_819621bcb8f44566a1bd8ea63d06c58f/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_819621bcb8f44566a1bd8ea63d06c58f/static/dark/3.0',
    },
    start: 297,
    end: 302,
  },
  {
    type: 'twitch',
    name: 'KPOPTT',
    id: '304047269',
    gif: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/304047269/default/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/304047269/default/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/304047269/default/dark/3.0',
    },
    start: 303,
    end: 308,
  },
  {
    type: 'twitch',
    name: 'FrogPonder',
    id: 'emotesv2_a3cdcbfcae9b41bb8215b012362eea35',
    gif: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_a3cdcbfcae9b41bb8215b012362eea35/default/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_a3cdcbfcae9b41bb8215b012362eea35/default/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_a3cdcbfcae9b41bb8215b012362eea35/default/dark/3.0',
    },
    start: 310,
    end: 319,
  },
  {
    type: 'twitch',
    name: 'HypeCheer',
    id: 'emotesv2_dd4f4f9cea1a4039ad3390e20900abe4',
    gif: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dd4f4f9cea1a4039ad3390e20900abe4/default/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dd4f4f9cea1a4039ad3390e20900abe4/default/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dd4f4f9cea1a4039ad3390e20900abe4/default/dark/3.0',
    },
    start: 321,
    end: 329,
  },
  {
    type: 'twitch',
    name: 'HypeFail',
    id: 'emotesv2_0330a84e75ad48c1821c1d29a7dadd4d',
    gif: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0330a84e75ad48c1821c1d29a7dadd4d/default/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0330a84e75ad48c1821c1d29a7dadd4d/default/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0330a84e75ad48c1821c1d29a7dadd4d/default/dark/3.0',
    },
    start: 0,
    end: 7,
  },
  {
    type: 'twitch',
    name: 'HypePopcorn',
    id: 'emotesv2_7b8e74be7bd64601a2608c2ff5f6eb7a',
    gif: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7b8e74be7bd64601a2608c2ff5f6eb7a/default/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7b8e74be7bd64601a2608c2ff5f6eb7a/default/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7b8e74be7bd64601a2608c2ff5f6eb7a/default/dark/3.0',
    },
    start: 9,
    end: 19,
  },
  {
    type: 'twitch',
    name: 'GlitchCat',
    id: '304486301',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/304486301/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/304486301/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/304486301/static/dark/3.0',
    },
    start: 21,
    end: 30,
  },
  {
    type: 'twitch',
    name: 'SoonerLater',
    id: '2113050',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/2113050/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/2113050/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/2113050/static/dark/3.0',
    },
    start: 31,
    end: 42,
  },
  {
    type: 'twitch',
    name: 'FBBlock',
    id: '1441276',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1441276/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1441276/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1441276/static/dark/3.0',
    },
    start: 43,
    end: 50,
  },
  {
    type: 'twitch',
    name: 'FBCatch',
    id: '1441281',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1441281/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1441281/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1441281/static/dark/3.0',
    },
    start: 51,
    end: 58,
  },
  {
    type: 'twitch',
    name: 'FBPass',
    id: '1441271',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1441271/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1441271/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1441271/static/dark/3.0',
    },
    start: 59,
    end: 65,
  },
  {
    type: 'twitch',
    name: 'FBRun',
    id: '1441261',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1441261/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1441261/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1441261/static/dark/3.0',
    },
    start: 66,
    end: 71,
  },
  {
    type: 'twitch',
    name: 'FBtouchdown',
    id: '626795',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/626795/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/626795/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/626795/static/dark/3.0',
    },
    start: 72,
    end: 83,
  },
  {
    type: 'twitch',
    name: 'FBSpiral',
    id: '1441273',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1441273/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1441273/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1441273/static/dark/3.0',
    },
    start: 84,
    end: 92,
  },
  {
    type: 'twitch',
    name: 'FBPenalty',
    id: '1441289',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1441289/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1441289/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1441289/static/dark/3.0',
    },
    start: 93,
    end: 102,
  },
  {
    type: 'twitch',
    name: 'FBChallenge',
    id: '1441285',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1441285/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1441285/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1441285/static/dark/3.0',
    },
    start: 103,
    end: 114,
  },
  {
    type: 'twitch',
    name: 'PixelBob',
    id: '1547903',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/1547903/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/1547903/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/1547903/static/dark/3.0',
    },
    start: 115,
    end: 123,
  },
  {
    type: 'twitch',
    name: 'LUL',
    id: '425618',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/425618/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/425618/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/425618/static/dark/3.0',
    },
    start: 124,
    end: 127,
  },
  {
    type: 'twitch',
    name: 'DarkMode',
    id: '461298',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/461298/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/461298/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/461298/static/dark/3.0',
    },
    start: 128,
    end: 136,
  },
  {
    type: 'twitch',
    name: 'PopCorn',
    id: '724216',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/724216/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/724216/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/724216/static/dark/3.0',
    },
    start: 137,
    end: 144,
  },
  {
    type: 'twitch',
    name: 'EarthDay',
    id: '959018',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/959018/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/959018/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/959018/static/dark/3.0',
    },
    start: 145,
    end: 153,
  },
  {
    type: 'twitch',
    name: 'TwitchUnity',
    id: '196892',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/196892/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/196892/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/196892/static/dark/3.0',
    },
    start: 154,
    end: 165,
  },
  {
    type: 'twitch',
    name: 'Squid1',
    id: '191762',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/191762/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/191762/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/191762/static/dark/3.0',
    },
    start: 166,
    end: 172,
  },
  {
    type: 'twitch',
    name: 'Squid2',
    id: '191763',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/191763/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/191763/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/191763/static/dark/3.0',
    },
    start: 173,
    end: 179,
  },
  {
    type: 'twitch',
    name: 'Squid3',
    id: '191764',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/191764/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/191764/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/191764/static/dark/3.0',
    },
    start: 180,
    end: 186,
  },
  {
    type: 'twitch',
    name: 'Squid4',
    id: '191767',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/191767/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/191767/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/191767/static/dark/3.0',
    },
    start: 187,
    end: 193,
  },
  {
    type: 'twitch',
    name: 'DinoDance',
    id: 'emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7',
    gif: true,
    animated: true,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7/animated/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7/animated/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7/animated/dark/3.0',
    },
    start: 194,
    end: 203,
  },
  {
    type: 'twitch',
    name: 'CrreamAwk',
    id: '191313',
    gif: false,
    animated: false,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/191313/static/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/191313/static/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/191313/static/dark/3.0',
    },
    start: 204,
    end: 213,
  },
  {
    type: 'twitch',
    name: 'PopNemo',
    id: 'emotesv2_5d523adb8bbb4786821cd7091e47da21',
    gif: true,
    animated: true,
    urls: {
      '1': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_5d523adb8bbb4786821cd7091e47da21/animated/dark/1.0',
      '2': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_5d523adb8bbb4786821cd7091e47da21/animated/dark/2.0',
      '4': 'https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_5d523adb8bbb4786821cd7091e47da21/animated/dark/3.0',
    },
    start: 214,
    end: 221,
  },
];

const emotes: Array<TwitchEmote | BttvEmote | SeventvEmote> = Object.values([
  ...TwitchEmotes,
  ...BttvEmotes.map((e) => ({
    type: e.platform,
    name: e.name,
    id: e.id,
    gif: e.animated,
    animated: e.animated,
    urls: e.urls,
  })),
  ...SeventvEmotes.map((e) => ({
    type: e.platform,
    name: e.name,
    id: e.id,
    gif: e.animated,
    animated: e.animated,
    urls: e.urls,
  })),
  ...FfzEmotes.map((e) => ({
    type: e.platform,
    name: e.name,
    id: e.id,
    gif: e.animated,
    animated: e.animated,
    urls: e.urls,
  })),
]).reduce(
  (acc, emote) => {
    if ((emote as any)?.platform) {
      emote.type = (emote as any).platform;
      delete (emote as any).platform;
    }

    if (!acc.some((e) => e.name === emote.name)) {
      acc.push({
        ...emote,
        start: 0,
        end: 0,
      } as TwitchEmote | BttvEmote | SeventvEmote);
    }

    return acc;
  },
  [] as Array<TwitchEmote | BttvEmote | SeventvEmote>,
);

export { TwitchEmotes, BttvEmotes, SeventvEmotes, FfzEmotes, emotes };
